/* eslint-disable max-len */
import { createGlobalStyle } from 'styled-components';

export const TooltipGlobalStyles = createGlobalStyle`
  .ant-tooltip {
    .ant-tooltip-content {
      .ant-tooltip-inner {
        ${(props): string => props.theme.fontStyles.redesign.base.normal};
        border-radius: 0;
        background-color: ${(props): string => props.theme.colors.black};
        padding: 8px;
        min-height: auto;
      }
    }
  }
`;
